import { Flex, Image, Text } from '@mantine/core';
export type TokenTabItemProps = {
  tokenImage: string | undefined;
  tokenName: string;
};
export const TokenTabItem: React.FC<TokenTabItemProps> = ({
  tokenImage,
  tokenName
}) => {
  return <Flex direction={{
    base: 'column',
    sm: 'row'
  }} align="center" gap={{
    base: 4,
    sm: 10
  }}>
      <Image src={tokenImage} alt="icon" w={{
      base: 32,
      sm: 36
    }} h={{
      base: 32,
      sm: 36
    }} />
      <Text fz={{
      base: 10,
      sm: 12
    }} c="inherit" fw={700}>
        {tokenName}
      </Text>
    </Flex>;
};